import React from "react";
import tw, { styled, css } from "twin.macro";
import { useStaticQuery, graphql, Link as Glink } from "gatsby";
import { BsArrowUpRight } from "react-icons/bs";
import { useInView } from "react-intersection-observer";

const Section = tw.section`bg-dark py-20 lg:py-48 relative flex flex-col items-center justify-center px-4 sm:px-10`;
const Wrapper = tw.div`flex flex-col items-center max-w-[85rem] w-full justify-center border-t border-b border-white border-opacity-20 pt-12 pb-28 lg:pb-12 xl:pl-16`;
const Title = tw.h2`text-center text-primary text-6xl font-mazuis italic mb-16 sm:self-start font-variant-ligatures[none]`;
const Cases = tw.div`grid grid-cols-1 items-center lg:(flex gap-0 w-full) justify-between gap-16 mb-16`;
const Case = styled.div(({ inview }) => [
  tw`flex flex-col w-full max-w-[20rem] md:max-w-[30rem] duration-1000 ease-in-out lg:(max-w-none w-auto) items-end justify-center gap-2 translate-y-[50px] blur-sm opacity-0`,
  inview && tw`blur-0 translate-y-0 opacity-100`,
  css`
    /* &:hover {
      .cr-top {
        ${tw`text-gold`}
      }
    } */
  `,
]);

const Top = tw.div`flex flex-row text-white font-mazuis italic text-6xl md:text-8xl 2xl:text-8xl duration-500 ease-in-out pb-10 sm:pb-4`;
const Desc = tw.div`text-primary absolute bottom-0  font-bold sm:whitespace-nowrap left-full text-sm translate-x-[-6.5rem] md:translate-x-[-10.5rem]`;

const Link = styled(Glink)`
  ${tw`font-gothic flex flex-row items-center self-end gap-2 mt-12 leading-none tracking-widest text-white uppercase`}

  .arrow {
    ${tw`duration-500 ease-in-out`}
  }

  span {
    ${tw`duration-500 ease-in-out`}
  }

  &:hover {
    span {
      ${tw`text-gold`}
    }

    .arrow {
      ${tw`scale-[130%] translate-y-[-15%] translate-x-[15%] text-gold`}
    }
  }
`;

const Disc = tw.p`text-white md:absolute bottom-0 left-0 mt-12 md:(mb-28 mt-0 mx-10) lg:mb-20 text-sm px-4 max-w-[30rem]`;

const CaseResults = ({ ...rest }) => {
  let { title, link, cases } = useStaticQuery(graphql`
    {
      wp {
        acfOptionsFeaturedCaseResults {
          featuredCaseResults {
            title: fcrTitle
            link: fcrLink {
              ...Button
            }
            cases: fcrCases {
              descr: case
              link {
                ...Button
              }
              magnitude
              value
            }
          }
        }
      }
    }
  `).wp.acfOptionsFeaturedCaseResults.featuredCaseResults;

  cases.forEach((caseItem) => {
    const [ref, inView] = useInView({
      threshold: 0.25,
      triggerOnce: true,
    });
    caseItem.ref = ref;
    caseItem.inView = inView;
  });

  return (
    <Section {...rest}>
      <Wrapper>
        <Title>{title}</Title>
        <Cases>
          {cases.map(({ descr, link, ref, inView, magnitude, value }, i) => {
            return (
              <Case
                key={i}
                ref={ref}
                inview={inView}
                // href={link.url}
                // target={link?.target ? link.target : null}
              >
                <Top className="cr-top">{`${value}${magnitude} — `}</Top>
                <Desc>{descr}</Desc>
              </Case>
            );
          })}
        </Cases>
        <Link to={link.url}>
          <span>{`${link.title} `}</span>
          <BsArrowUpRight className="arrow" />
        </Link>
      </Wrapper>
      <Disc>
        <span tw="text-gold">* </span>
        As to the case results mentioned above, attorney Kila Baldwin co-led the
        trial team at her prior firm that obtained these verdicts.
      </Disc>
    </Section>
  );
};

export default CaseResults;
